import { Injectable, Inject } from '@angular/core';
import { expEnvironmentRef } from '../../injection-tokens/environment.injection-token';
import { EnvironmentRef } from '../../../environments/interfaces/';

import { NGXLogger } from 'ngx-logger';

/* eslint-disable */
let LoggerObject: any;
/* eslint-enable */

@Injectable({
	providedIn: 'root'
})
export class LoggerService 
{
	constructor(
    private readonly logger: NGXLogger,
    @Inject(expEnvironmentRef) readonly environmentRef: EnvironmentRef
	) {}

	private checkToDisplayLogs(): boolean 
	{
		return !this.environmentRef.production;
	}

	public trace(traceMsg: string, traceObj?: typeof LoggerObject): void 
	{
		if (this.checkToDisplayLogs()) 
		{
			this.logger.trace(traceMsg, traceObj ?? '');
		}
	}

	public debug(debugMsg: string, debugObj?: typeof LoggerObject): void 
	{
		if (this.checkToDisplayLogs()) 
		{
			this.logger.debug(debugMsg, debugObj ?? '');
		}
	}

	public info(infoMsg: string, infoObj?: typeof LoggerObject): void 
	{
		if (this.checkToDisplayLogs()) 
		{
			this.logger.info(infoMsg, infoObj ?? '');
		}
	}

	public log(logMsg: string, logObj?: typeof LoggerObject): void 
	{
		if (this.checkToDisplayLogs()) 
		{
			this.logger.log(`${logMsg} ${logObj ?? ''}`);
		}
	}

	public warn(warnMsg: string, warnObj?: typeof LoggerObject): void 
	{
		if (this.checkToDisplayLogs()) 
		{
			this.logger.warn(warnMsg, warnObj ?? '');
		}
	}

	public error(errorMsg: string, errorObj?: typeof LoggerObject): void 
	{
		if (this.checkToDisplayLogs()) 
		{
			this.logger.error(errorMsg, errorObj ?? '');
		}
	}
}
